import { Outlet } from 'react-router-dom';

function GalleryShell() {
  return <Outlet />;
}

export default GalleryShell;
